
<template>
  <v-treeview
    ref="catalog"
    activatable
    :active="positions"
    active-class="black--text"
    color="var(--black-color)"
    hoverable
    :item-disabled="itemDisabled"
    :item-key="itemKey"
    item-text="title"
    :items="items"
    :load-children="loadChildren"
    multiple-active
    :open.sync="opened"
    :open-on-click="openOnClick"
    return-object
    :search="search"
    selected-color="var(--black-color)"
    transition
    :value="positions"
    @input="select">
    <template #label="{ item, selected }">
      <div
        class="tree-item black--text pr-3"
        @click="change(item, !selected)">
        <slot name="tree-name">
          {{ item.name || item.fullName || item.title }}
        </slot>
      </div>
    </template>
    <template #prepend="{ item, indeterminate, open: openPrepend, selected }">
      <slot name="prepend">
        <div class="flex flex-wrap align-center">
          <sIcon
            v-if="!!item.children"
            :rotate="openPrepend ? 0 : -90"
            size="10"
            type="arrow"/>
          <v-checkbox
            class="ma-0 my-auto pa-0"
            :disabled="!!item.children || selectDisable"
            hide-details
            :indeterminate="indeterminate"
            :input-value="selected"
            @change="change(item, !selected)"/>
          <sIcon
            v-if="loading(item)"
            color="var(--secondary__green_not_active)"
            size="22"
            spin
            type="loading"/>
        </div>
      </slot>
    </template>
    <template #append="{ item }">
      <slot name="append">
        <span
          class="secondary__green_not_active--text mr-3"
          :title="append_text_title(item)">
          {{ append_text(item) }}
        </span>
      </slot>
    </template>
  </v-treeview>
</template>
<script>
/* eslint-disable vue/prop-name-casing */
export default {
  name: 'resourceTree',
  props: {
    openOnClick: Boolean,
    itemDisabled: String,
    loadChildren: Function,
    selectDisable: Boolean,
    selected_positions: Array,
    items: Array,
    open: Array,
    search: String,
    itemKey: String,
    loading: Function,
    outline_folder: Function,
    outlined_file: Function,
    append_text: Function,
    append_text_title: Function
  },
  computed: {
    positions: {
      get() {
        return this.selected_positions
      },
      set(value) {
        value.forEach(element => {
          const oldLotNumber = this.selected_positions.find(i => i.nomenclatureId === element.nomenclatureId && i.title === element.title)
          if (oldLotNumber) {
            element.lotNumber = oldLotNumber?.lotNumber
          }
        })
        this.$emit('update:selected_positions', value)
      }
    },
    opened: {
      get() {
        return this.open
      },
      set(value) {
        this.$emit('update:open', value)
      }
    },
  },
  methods: {
    change(item,  selected) {
      if ( item.children || this.selectDisable ) { return }
      let result = this.$_.cloneDeep(this.selected_positions)
      if (!selected) {
        result = result.filter(i => i.id !== item.id)
      } else {
        result.push(item)
      }
      this.positions = result
    },
    select(input) {
      this.$emit('input', input)
    },
  }
}
</script>
